// Staff pages scroll inside the app shell's content pane (#content-scroll in
// main.templ), not the window. An in-place navigation swaps #main-content
// inside that pane and htmx never touches the pane's scrollTop, so without a
// reset the new page opens at the old page's offset - clamped to the bottom
// when the new page is shorter.
//
// Wired to htmx:beforeHistoryUpdate, which htmx fires on document.body right
// before the swap with detail = {history: {type, path}, ...responseInfo};
// detail.target is the final swap target (after any HX-Retarget). The reset
// runs in the same task as the swap, so nothing paints in between, and it runs
// before settle, so URL anchors and autofocus still scroll afterwards.

export const MAIN_CONTENT_ID = "main-content";
export const CONTENT_SCROLL_ID = "content-scroll";

export interface HistoryUpdateDetail {
    history?: { type?: string };
    target?: Element | null;
}

// A push into #main-content is a page change. A replace (in-page state) or a
// push into a sub-region (calendar grid, tab region) keeps the reader's place.
export function isMainNavigation(detail: HistoryUpdateDetail): boolean {
    return detail.history?.type === "push" && detail.target?.id === MAIN_CONTENT_ID;
}

export function resetScrollOnNavigation(detail: HistoryUpdateDetail, doc: Document): void {
    if (!isMainNavigation(detail)) return;
    const pane = doc.getElementById(CONTENT_SCROLL_ID);
    if (pane) pane.scrollTop = 0;
}
